import { map, switchMap } from 'rxjs';
import type { Observable } from 'rxjs';
import { post } from '@/shared/api/http';
import { refreshUser } from '@/shared/api/user.api';

interface BackendOperator {
  id: string;
  name: string;
  registration_number: string;
  registration_valid_until: string;
}

export function addOperator(params: {
  name: string;
  registrationNumber: string;
  registrationValidUntil: string;
}): Observable<string> {
  return post<BackendOperator>('/api/v1/operators/', {
    name: params.name,
    registration_number: params.registrationNumber,
    registration_valid_until: params.registrationValidUntil,
  }).pipe(
    switchMap(op => refreshUser().pipe(map(() => op.registration_number)))
  );
}
